<template>
    <div class="base-nickname" :class="{'nickname-sp': $store.state.screen == 1}">
        <div class="content">
            <div class="title">修改用户昵称</div>
            <input class="val" type="text" maxlength="16" placeholder="请输入新的用户昵称（2~16个字符）" v-model="names" />
            <div class="btn">
                <div class="item" @click="onOut">暂不修改</div>
                <div class="item" @click="submit">确认修改</div>
            </div>
            <transition name="component-fade" mode="out-in">
                <TheTips :msg='msg' v-if="msg" />
            </transition>
        </div>
    </div>
</template>

<script>
    import TheTips from '@/components/TheTips'

    export default {
        props: {
            name: String
        },
        components: {
            TheTips
        },
        data () {
            return {
                msg: null,
                names: ''
            }
        },
        methods: {
            // 关闭弹窗
            onOut () {
                this.$emit('childName', null)
            },
            // 修改昵称
            submit () {
                if (!this.names.replace(/\s*/g, "")) {
                    this.msg = '昵称不能为空'
                    setTimeout(() => {
                        this.msg = null
                    }, 2000)
                    return false
                }
                if (this.names.replace(/\s*/g, "").length < 2 || this.names.replace(/\s*/g, "").length > 16) {
                    this.msg = '请输入2~16个字符'
                    setTimeout(() => {
                        this.msg = null
                    }, 2000)
                    return false
                }
                let uid = JSON.parse(sessionStorage.getItem('accountData')).uid
                let options = {
                    id: uid,
                    nick_name: this.names
                }
                this.$axios.post('https://sdk.gameschain.pro/index.php?g=api&m=userbox&a=modify_nickname', this.$qs.stringify(options)).then(res => {
                    if (res.data.status == 1) {
                        this.msg = '修改成功'
                        setTimeout(() => {
                            this.msg = null
                            this.$emit('childName', null)
                        }, 1000)
                    } else {
                        this.msg = res.data.msg
                        setTimeout(() => {
                            this.msg = null
                        }, 2000)
                    }
                }).
                catch(o => {
                    this.msg = '请求失败'
                    setTimeout(() => {
                        this.msg = null
                    }, 2000)
                })
            }
        },
        created () {
            this.names = this.name
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../../static/tctransition";
    $color: #FF6C22; // 主体颜色
    // 横屏css
    .base-nickname {
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        transition: all 0.3s;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 999;
        .content {
            width: 840px;
            overflow: hidden;
            border-radius: 18px;
            background: $color;
            overflow: hidden;
            padding: 0 60px 60px;
            position: relative;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            .title {
                height: 160px;
                font-size: 51px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .val {
                width: 100%;
                height: 120px;
                color: #fff;
                font-size: 39px;
                border-radius: 18px;
                border: 0;
                background: rgba(255, 255, 255, 0.2);
                padding: 0 45px;
                outline: none;
            }
            input::-webkit-input-placeholder{
                color:rgba(255, 255, 255, 0.5);
            }
            input::-moz-input-placeholder{
                color:rgba(255, 255, 255, 0.5);
            }
            input::-ms-input-placeholder{
                color:rgba(255, 255, 255, 0.5);
            }
            input::-o-input-placeholder{
                color:rgba(255, 255, 255, 0.5);
            }
            .btn {
                height: 120px;
                margin-top: 55px;
                display: flex;
                justify-content: space-between;
                .item {
                    width: 345px;
                    height: 120px;
                    color: $color;
                    font-size: 39px;
                    border-radius: 18px;
                    background: #fff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .item:first-child {
                    background: rgba(255, 255, 255, 0.8);
                }
            }
        }
    }
    // 竖屏css
    .nickname-sp {
        .content {
            width: 1527px;
            border-radius: 32px;
            padding: 0 90px 90px;
            .title {
                height: 290px;
                font-size: 92px;
            }
            .val {
                height: 200px;
                font-size: 70px;
                border-radius: 32px;
                padding: 0 81px;
            }
            .btn {
                height: 200px;
                margin-top: 100px;
                .item {
                    width: 627px;
                    height: 200px;
                    font-size: 70px;
                    border-radius: 32px;
                }
            }
        }
    }
</style>